"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var react_spinners_1 = require("react-spinners");

var playButton = require('../../../assets/icon_play_button.svg');

var pauseButton = require('../../../assets/icon_pause_button.svg');

exports.CustomControls = function (_a) {
  var isVideoPlaying = _a.isVideoPlaying,
      isLoading = _a.isLoading,
      mouseMoving = _a.mouseMoving,
      customControls = _a.customControls,
      controls = _a.controls,
      play = _a.play,
      pause = _a.pause,
      color = _a.color;

  if (isLoading) {
    return react_1["default"].createElement(Overlay, {
      isVideoPlaying: isVideoPlaying,
      mouseMoving: mouseMoving
    }, react_1["default"].createElement("div", {
      className: "loader"
    }, react_1["default"].createElement(react_spinners_1.MoonLoader, {
      color: color
    })));
  } else if (customControls && controls) {
    return react_1["default"].createElement(Overlay, {
      isVideoPlaying: isVideoPlaying,
      mouseMoving: mouseMoving
    }, react_1["default"].createElement("img", {
      src: isVideoPlaying ? pauseButton : playButton,
      onClick: function onClick() {
        isVideoPlaying ? pause() : play();
      }
    }));
  } else return null;
};

exports.SharedOverlayStyles = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n  transition: background-color 0.4s ease;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n  transition: background-color 0.4s ease;\n"])));
exports.SharedPlayButtonStyles = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 80px;\n  height: 80px;\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  width: 80px;\n  height: 80px;\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var Overlay = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n", "\n  background-color: ", ";\n\n  .loader,\n  img {\n", "    \n    transition: opacity 0.4s ease;\n    opacity: ", ";\n  }\n"], ["\n", "\n  background-color: ", ";\n\n  .loader,\n  img {\n", "    \n    transition: opacity 0.4s ease;\n    opacity: ", ";\n  }\n"])), exports.SharedOverlayStyles, function (_a) {
  var isVideoPlaying = _a.isVideoPlaying,
      mouseMoving = _a.mouseMoving;
  return !isVideoPlaying || mouseMoving ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0)';
}, exports.SharedPlayButtonStyles, function (_a) {
  var isVideoPlaying = _a.isVideoPlaying,
      mouseMoving = _a.mouseMoving;
  return !isVideoPlaying || mouseMoving ? '1' : '0';
});
var templateObject_1, templateObject_2, templateObject_3;